import script from "./serviceChat.vue?vue&type=script&setup=true&lang=js"
export * from "./serviceChat.vue?vue&type=script&setup=true&lang=js"

import "./serviceChat.vue?vue&type=style&index=0&id=146d44a2&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-146d44a2"]])

export default __exports__